module.exports = __webpack_public_path__ + "media/images/pc/top/icon-location_white-0cc23a1aeec2118554984179a70058a0.svg";